import { useEffect } from "react"
import ScrollReveal from "scrollreveal"
import styles from "./SeventhScreen.module.css"
import image1 from "../images/אירועים 1.webp"
import image2 from "../images/אירועים 2.webp"
import image3 from "../images/אירועים 3.webp"
import image4 from "../images/אירועים 4.webp"
import image5 from "../images/אירועים 5.webp"
import image6 from "../images/אירועים 6.webp"
import image7 from "../images/אירועים 7.webp"
import image8 from "../images/אירועים 8.webp"
import image9 from "../images/אירועים 9.webp"
import image10 from "../images/אירועים 10.webp"
import image11 from "../images/אירועים 11.webp"
import image12 from "../images/אירועים 12.webp"
import image13 from "../images/אירועים 13.webp"
import image14 from "../images/אירועים 14.webp"
import image15 from "../images/אירועים 15.webp"
import image16 from "../images/אירועים 16.webp"
import image17 from "../images/אירועים 17.webp"
import image18 from "../images/אירועים 18.webp"
import image19 from "../images/אירועים 19.webp"
import image20 from "../images/אירועים 20.webp"

const SeventhScreen = () => {
  const celebrities = [
    { id: 9, src: image9, alt: "אירוע 9" },
    { id: 10, src: image10, alt: "אירוע 10" },
    { id: 11, src: image11, alt: "אירוע 11" },
    { id: 12, src: image12, alt: "אירוע 12" },
    { id: 13, src: image13, alt: "אירוע 13" },
    { id: 14, src: image14, alt: "אירוע 14" },
    { id: 15, src: image15, alt: "אירוע 15" },
    { id: 16, src: image16, alt: "אירוע 16" },
    { id: 17, src: image17, alt: "אירוע 17" },
    { id: 18, src: image18, alt: "אירוע 18" },
    { id: 19, src: image19, alt: "אירוע 19" },
    { id: 20, src: image20, alt: "אירוע 20" },
    { id: 1, src: image1, alt: "אירוע 1" },
    { id: 2, src: image2, alt: "אירוע 2" },
    { id: 3, src: image3, alt: "אירוע 3" },
    { id: 4, src: image4, alt: "אירוע 4" },
    { id: 5, src: image5, alt: "אירוע 5" },
    { id: 6, src: image6, alt: "אירוע 6" },
    { id: 7, src: image7, alt: "אירוע 7" },
    { id: 8, src: image8, alt: "אירוע 8" },
  ];

  useEffect(() => {
    // אנימציה לכותרת
    ScrollReveal().reveal(`.${styles.title}`, {
      origin: 'top',
      distance: '50px',
      duration: 1000,
      delay: 200,
      opacity: 0,
      easing: 'ease-out',
      reset: false
    });

    // אנימציה לתמונות - כל תמונה בנפרד עם דיליי שונה
    ScrollReveal().reveal(`.${styles.imageWrapper}`, {
      origin: 'bottom',
      distance: '80px',
      duration: 800,
      delay: 100,
      opacity: 0,
      scale: 0.85,
      easing: 'cubic-bezier(0.5, 0, 0, 1)',
      interval: 150, // דיליי בין כל תמונה
      reset: false,
      mobile: true
    });

    // אנימציה לכפתור
    ScrollReveal().reveal(`.${styles.ctaButton}`, {
      origin: 'bottom',
      distance: '30px',
      duration: 1000,
      delay: 600,
      opacity: 0,
      scale: 0.9,
      easing: 'ease-out',
      reset: false
    });

    // ניקוי
    return () => {
      ScrollReveal().destroy();
    };
  }, []);

  const handleWhatsAppClick = () => {
    const phoneNumber = '972507277178';
    const message = 'היי חינת הזהב הגעתי מהדף שלכם, אשמח לשמוע עוד על..';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className={styles.background} id="מפורסמים">
      <div className={styles.headerSection}>
        <div className={styles.title}>
         מקבץ קטן מהזוגות המדהימים שעברו<span className={styles.goldText}> בחינת הזהב</span>
        </div>
      </div>
      
      <div className={styles.galleryContainer}>
        <div className={styles.gallery}>
          {celebrities.map((celebrity) => (
            <div key={celebrity.id} className={styles.imageWrapper}>
              <img
                src={celebrity.src}
                alt={celebrity.alt}
                className={styles.image}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
      
      <button className={styles.ctaButton} onClick={handleWhatsAppClick}>
        אילנית, בואי נדבר על האירוע שלי
      </button>
    </div>
  );
}

export default SeventhScreen;